import u from './utils'; 

// retorna false cuando no paso la validación
export const validarItem = ({valor, input, vacio, email, rut, texto, numero, select, txtnum, largo, archivo, repetido}) => {
    let inputM = input !== undefined ? ' "'+input+'" ' : ' ';

    let validaciones = []; 
    let arregloMensajes = [];
    let respuesta = [];
   if(vacio){
        let rVacio;
        if(valor===null){
            rVacio = false; 
        }else {
            rVacio = valor.length<=0 ? false : true; 
        }
        validaciones.push(rVacio)  
        if(!rVacio){ arregloMensajes.push('El campo'+inputM+'no puede estar vacío')}
   } 
   if(select){
        let rVacio;
        if(valor===null){
            rVacio = false; 
        } else if(valor==='Seleccione'){
            rVacio = false; 
        }
        else {
            rVacio = valor.length<=0 ? false : true; 
        }
        validaciones.push(rVacio)  
        if(!rVacio){ arregloMensajes.push('Debe seleccionar alguna opción en el campo '+inputM)}
   } 
   if(email){
        let rEmail = u.validateEmail(valor);
        validaciones.push(rEmail);
        if(!rEmail){ arregloMensajes.push('Email no válido en el campo'+inputM)}
   }
   if(rut){
       let rRut = u.validaRut(valor);
       validaciones.push(rRut); 
       if(!rRut){ arregloMensajes.push('Rut no válido en el campo'+inputM)}
   }

   if(texto){
        let rTexto = typeof(valor) !== 'string' ? false : true;
        
        let patron = new RegExp('^[A-Za-z äÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ]*[A-Za-z][A-Za-z äÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ]*$');
        if(!patron.test(valor)){ 
            rTexto = false;
        } else {
            rTexto = true;
        }

        validaciones.push(rTexto);

        if(!rTexto && valor.length>0){ arregloMensajes.push('El campo'+inputM+'solo puede contener letras')}     
   }

   if(numero){
        let rNum = typeof(valor) !== 'number' ? false : true;
        validaciones.push(rNum); 
        if(!rNum){ arregloMensajes.push('El campo'+inputM+'solo puede contener números')}     
   }

   if(largo){
        let num = parseInt(largo); 
        if(!isNaN(num) && valor.length<=num){
            validaciones.push(true); 
        }else {
            validaciones.push(false);   
            arregloMensajes.push('El largo del contenido del campo'+inputM+'no puede superar los '+num+' caracteres')
        }
     
   }

    if(archivo){
        if (valor!==null) {
            if (Array.isArray(valor)) {
                if(valor.length>0 ){
                    validaciones.push(true); 
                } else {
                    validaciones.push(false); 
                    arregloMensajes.push('Se debe cargar al menos un archivo.')
                } 
            } else {
                validaciones.push(true); 
            }

        } else {
            validaciones.push(false); 
            arregloMensajes.push('Se debe cargar al menos un archivo.')
        }
        
    }
    //recive objeto {valor, arreglo}
    if(repetido!== null && repetido!==undefined && repetido.valor!== null && repetido.valor!==undefined && repetido.arreglo!== null && repetido.arreglo!==undefined){
        if (!repetido.arreglo.includes(repetido.valor) ) {
            validaciones.push(true); 
        }else{
            validaciones.push(false); 
            respuesta.push({validador:'repetido'});
            arregloMensajes.push('El campo'+inputM+' no puede usar un valor ya utilizado')
        }

         
    }


    // si existe un false retornara true
    let resultadoValidacion = validaciones.some(element => {
        return element === false;
    });

    let resultado = !resultadoValidacion; 

   return {resultado:resultado, mensajes: arregloMensajes, respuesta:respuesta}
}
  


export const listaMensajes = (arreglo) => {

    let lista = []; 

    for (const m in arreglo) {
        let mensajes = arreglo[m].mensajes;
        for (const k in mensajes) {
            lista.push(mensajes[k]);
            
        }
         
    }
 
    return lista; 
}

export const validarFormulario = (arreglo) => {
    let validaciones = []; 

    for (const a in arreglo) {
        let resultado = arreglo[a].resultado;
        validaciones.push(resultado);
    }

    let resultadoValidacion = validaciones.some(element => {
        return element === false;
    });

    let mensajes = listaMensajes(arreglo); 

    return {resultado:!resultadoValidacion, mensajes: mensajes}; 
}


